module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavysnow-4ec97212cae84c00146b46901e9a1f3f.png";